(function () {
  'use strict';

  var root = document.documentElement;
  var config = window.tfmcPurityIqRegionConfig;
  if (!config || root.hasAttribute('data-tfmc-purity-iq-initialised')) return;
  root.setAttribute('data-tfmc-purity-iq-initialised', 'true');
  root.setAttribute('data-tfmc-purity-iq-state', 'pending');
  root.setAttribute('data-tfmc-purity-iq-country', 'unknown');

  var marker = 'data-tfmc-purity-iq';
  var copyMarker = 'data-tfmc-purity-iq-copy';
  var readyMarker = 'data-tfmc-purity-iq-ready';
  var excluded = 'head,script,style,template,noscript,[' + marker + ']';
  var brand = /\bpurity[\s_\-\u2010-\u2015]*iq\b/i;
  var asset = /purity[\s_\-]*iq|piq_eng/i;
  var units = '.ez-cert__mark,.dk-std__cell,.announcement--block';
  var paragraphs = 'p,li,dd,dt,h1,h2,h3,h4,h5,h6,figcaption,summary,blockquote';
  var assetAttributes = ['src', 'srcset', 'data-src', 'data-srcset', 'poster', 'style'];

  function ignored(element) {
    return !element || !!element.closest(excluded);
  }

  function mark(element) {
    if (element && !ignored(element)) element.setAttribute(marker, '');
  }

  function logoUnit(element) {
    var unit = element.closest(units);
    if (unit) return unit;
    var picture = element.closest('picture');
    var image = picture || element;
    var parent = image.parentElement;
    if (parent && parent.tagName === 'A' && !parent.textContent.trim()) {
      image = parent;
      parent = image.parentElement;
    }
    // Only collapse a simple image wrapper, never a row of other logos.
    if (parent && parent.tagName === 'DIV' && parent.children.length === 1 &&
        !parent.textContent.trim()) return parent;
    return image;
  }

  function isReportLink(element) {
    if (!element.hasAttribute('href')) return false;
    try {
      var link = new URL(element.getAttribute('href'), window.location.href);
      return link.hostname.toLowerCase() === 'tapscan.io' &&
        /^\/fm-home\/?$/i.test(link.pathname);
    } catch (_) {
      return false;
    }
  }

  function inspectAttributes(element) {
    if (ignored(element)) return;
    var hasAsset = assetAttributes.some(function (name) {
      return asset.test(element.getAttribute(name) || '');
    });
    if (hasAsset) {
      mark(logoUnit(element));
      return;
    }
    if (isReportLink(element)) {
      mark(element.closest(units) || element);
      return;
    }
    // A brand can also be supplied solely as an image's accessible name.
    if (element.matches('img,svg,picture') &&
        brand.test((element.getAttribute('alt') || '') + ' ' +
          (element.getAttribute('aria-label') || '') + ' ' +
          (element.getAttribute('title') || ''))) {
      mark(logoUnit(element));
    }
  }

  function textParts(element) {
    var walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        return ignored(node.parentElement) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    var text = '';
    var node;
    while ((node = walker.nextNode())) {
      nodes.push({ node: node, start: text.length, end: text.length + node.data.length });
      text += node.data;
    }
    return { nodes: nodes, text: text };
  }

  function sentences(text) {
    var result = [];
    var boundary = /[.!?]+["'\u2019\u201d)]*(?=\s|$)|[\r\n]+/g;
    var start = 0;
    var match;
    while ((match = boundary.exec(text))) {
      result.push({ start: start, end: boundary.lastIndex });
      start = boundary.lastIndex;
    }
    if (start < text.length) result.push({ start: start, end: text.length });
    return result.filter(function (part) { return text.slice(part.start, part.end).trim(); });
  }

  function maskCopy(element) {
    if (ignored(element)) return;
    var parts = textParts(element);
    if (!brand.test(parts.text)) return;
    var unit = element.closest(units);
    if (unit) {
      mark(unit);
      return;
    }
    var allSentences = sentences(parts.text);
    var branded = allSentences.filter(function (part) {
      return brand.test(parts.text.slice(part.start, part.end));
    });
    if (!branded.length) return;
    if (branded.length === allSentences.length &&
        element.matches(paragraphs + ',span,a,[' + copyMarker + ']')) {
      mark(element);
      return;
    }

    // Wrap individual text fragments, working backwards. This keeps existing
    // inline links and emphasis intact rather than rebuilding their HTML.
    parts.nodes.slice().reverse().forEach(function (part) {
      branded.slice().reverse().forEach(function (sentence) {
        var start = Math.max(part.start, sentence.start) - part.start;
        var end = Math.min(part.end, sentence.end) - part.start;
        if (end <= start) return;
        var textNode = part.node;
        if (end < textNode.data.length) textNode.splitText(end);
        if (start > 0) textNode = textNode.splitText(start);
        var span = document.createElement('span');
        span.setAttribute(marker, '');
        textNode.parentNode.insertBefore(span, textNode);
        span.appendChild(textNode);
      });
    });

    // Do not leave an empty focusable link when its entire label was masked.
    element.querySelectorAll('a').forEach(function (link) {
      if (!ignored(link) && link.querySelector('[' + marker + ']') &&
          !textParts(link).text.trim() && !link.querySelector('img,svg,picture')) mark(link);
    });
  }

  function process(container) {
    if (!container || !container.isConnected) return;
    if (container.nodeType === Node.TEXT_NODE) container = container.parentElement;
    if (!container || container.nodeType !== Node.ELEMENT_NODE || ignored(container)) return;

    inspectAttributes(container);
    container.querySelectorAll('[src],[srcset],[data-src],[data-srcset],[poster],[style],[href],img,svg,picture')
      .forEach(inspectAttributes);

    // Paragraph-level matching also catches "Purity <strong>IQ</strong>".
    var candidates = [];
    if (container.matches(paragraphs)) candidates.push(container);
    container.querySelectorAll(paragraphs).forEach(function (element) { candidates.push(element); });
    // Process nested paragraphs before a surrounding list item or quotation.
    candidates.reverse().forEach(maskCopy);

    // Catch unstructured text and explicitly marked rich-copy containers.
    var parts = textParts(container);
    var remaining = new Set();
    parts.nodes.forEach(function (part) {
      var parent = part.node.parentElement;
      if (parent && brand.test(parent.textContent)) remaining.add(parent);
    });
    if (container.hasAttribute(copyMarker)) remaining.add(container);
    container.querySelectorAll('[' + copyMarker + ']').forEach(function (element) { remaining.add(element); });
    remaining.forEach(maskCopy);

    if (container.hasAttribute(copyMarker)) container.setAttribute(readyMarker, '');
    container.querySelectorAll('[' + copyMarker + ']:not([' + readyMarker + '])')
      .forEach(function (element) { element.setAttribute(readyMarker, ''); });
  }

  var pending = new Set();
  var scheduled = false;
  function queue(container) {
    if (container.nodeType === Node.TEXT_NODE) container = container.parentElement;
    if (!container || container.nodeType !== Node.ELEMENT_NODE || ignored(container)) return;
    // A nested inline update can complete a brand with text in its siblings.
    // Rescan that paragraph rather than looking only at the changed fragment.
    container = container.closest(paragraphs + ',[' + copyMarker + ']') || container;
    pending.add(container);
    if (scheduled) return;
    scheduled = true;
    Promise.resolve().then(function () {
      scheduled = false;
      var batch = new Set(pending);
      pending.clear();
      batch.forEach(function (element) {
        // Parsing or replacing one section produces several related records.
        // Its outermost queued element already covers all its descendants.
        var ancestor = element.parentElement;
        while (ancestor) {
          if (batch.has(ancestor)) return;
          ancestor = ancestor.parentElement;
        }
        process(element);
      });
    });
  }

  var observer = new MutationObserver(function (records) {
    records.forEach(function (record) {
      if (record.type === 'childList') {
        record.addedNodes.forEach(queue);
        // The added text may complete a brand across existing inline nodes.
        queue(record.target);
      } else {
        queue(record.target);
      }
    });
  });
  observer.observe(root, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: assetAttributes.concat(['href', 'alt', 'aria-label', 'title'])
  });
  if (document.body) process(document.body);
  document.addEventListener('DOMContentLoaded', function () {
    process(document.body);
  }, { once: true });

  // ISO country codes plus Shopify-documented territory exceptions. Unknown
  // region ZZ and arbitrary values cannot enable the content.
  var countries = new Set(('AC AN TA XK AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BV BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU ID IE IL IM IN IO IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TF TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG UM US UY UZ VA VC VE VG VI VN VU WF WS YE YT ZA ZM ZW').split(' '));
  var settled = false;
  var timer;
  function finish(country) {
    if (settled) return;
    settled = true;
    window.clearTimeout(timer);
    var valid = typeof country === 'string' && countries.has(country);
    root.setAttribute('data-tfmc-purity-iq-country', valid ? country : 'unknown');
    root.setAttribute('data-tfmc-purity-iq-state',
      valid && country !== 'US' && country !== 'CA' ? 'allow' : 'blocked');
  }

  try {
    var endpoint = new URL(config.endpoint, window.location.href);
    if (typeof config.endpoint !== 'string' || endpoint.origin !== window.location.origin) {
      finish(null);
      return;
    }
    var controller = new AbortController();
    timer = window.setTimeout(function () {
      finish(null);
      controller.abort();
    }, 5000);
    window.fetch(endpoint.href, {
      credentials: 'same-origin',
      redirect: 'error',
      cache: 'no-store',
      signal: controller.signal,
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Country lookup failed');
      return response.json();
    }).then(function (data) {
      var country = data && data.detected_values && data.detected_values.country &&
        data.detected_values.country.handle;
      finish(country);
    }).catch(function () { finish(null); });
  } catch (_) {
    finish(null);
  }
}());
